import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";

import { ConfigurationError } from "../../components/ConfigurationError";
import { useCanAccessSettings } from "../../components/permissions/Permissions";

export function RequireSettingsAccess() {
  const { t } = useTranslation();
  const canAccessSettings = useCanAccessSettings();

  if (!canAccessSettings) {
    return (
      <ConfigurationError
        message={t(
          "Hmm, it looks like you do not have permission to access settings."
        )}
      />
    );
  }

  return <Outlet />;
}
